import React, { useEffect, useState } from "react";
import { CircularProgress, Box } from "@mui/material";

function CenteredCircularProgress() {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const centerStyle = {
    position: "absolute",
    top: windowSize.height / 2,
    left: windowSize.width / 2,
    transform: "translate(-50%, -50%)",
  };

  return (
    <Box sx={centerStyle}>
      <CircularProgress />
    </Box>
  );
}

export default CenteredCircularProgress;
